<template>
  <div class="template3">
    <!-- 主内容区 -->
    <div class="t3-content">
      <!-- 顶部推荐图 -->
      <div class="t3-top-banner">
        <img src="/static/image/event/2035233566223306753_00.avif" class="top-banner-img" alt="" />
      </div>

      <!-- 活动详情+特惠整体区块 -->
      <div class="t3-card">
        <!-- 活动详情 -->
        <div v-if="activityData.content">
          <div class="t3-title">{{ activityData.title }}</div>
          <div class="t3-text" v-html="activityData.content"></div>
        </div>

        <!-- 综合优惠表格 -->
        <div class="t3-table-wrap" v-if="activityData.comprehensive">
          <table class="t3-table" v-for="(group, gi) in activityData.comprehensive" :key="gi">
            <tbody>
              <tr>
                <td colspan="4" class="t3-table-title">{{ group.title }}</td>
              </tr>
              <tr v-for="(row, ri) in chunkArray(group.items, 2)" :key="ri">
                <td>{{ row[0][0] }}</td>
                <td class="gold-link" @click="handleJump(row[0][1])">点击跳转</td>
                <td v-if="row[1]">{{ row[1][0] }}</td>
                <td v-else class="empty-cell"></td>
                <td v-if="row[1]" class="gold-link" @click="handleJump(row[1][1])">点击跳转</td>
                <td v-else class="empty-cell"></td>
              </tr>
            </tbody>
          </table>
          <div class="t3-table-note" v-if="activityData.note" v-html="activityData.note"></div>
        </div>
      </div>

      <!-- 领取方式卡片 -->
      <div class="t3-card" v-if="activityData.receiveMethod">
        <img src="/static/image/event/1998087813104230401_00000.avif" class="card-title-icon" alt="" />
        <div class="t3-text" v-html="activityData.receiveMethod"></div>
      </div>

      <!-- 活动说明/规则卡片 -->
      <div class="t3-card" v-if="activityData.memo">
        <div class="t3-rules-title">活动规则</div>
        <div class="t3-rules">
          <p v-for="(item, index) in activityData.memo" :key="index">{{ item }}</p>
        </div>
      </div>

      <!-- 底部推荐图横向滑动 -->
      <div class="t3-recommend" v-if="recommendList.length > 0" ref="recommendWrap">
        <div class="t3-recommend-inner" ref="recommendInner">
          <div
            v-for="(item, index) in recommendList"
            :key="index"
            class="t3-recommend-item"
            :ref="'recItem' + index"
            :class="{ 't3-recommend-active': item.activityId === String(activityData.id) }"
            @click="goRecommend(item)"
          >
            <img :src="item.image" class="t3-recommend-img" alt="" />
            <div class="t3-recommend-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部操作栏 -->
    <div class="t3-footer" v-if="showFooter">
      <div class="t3-footer-info">
        <span>剩余申请次数：{{ applyCount }}</span>
        <span class="t3-refresh" @click="handleRefresh"> 刷新次数</span>
      </div>
      <div class="t3-footer-btns">
        <button class="t3-btn t3-btn-back" @click="$router.back()">返回</button>
        <button class="t3-btn t3-btn-apply" @click="handleApply">优惠申请</button>
      </div>
    </div>

    <!-- 弹框 -->
    <div class="popup-overlay" v-if="showPopup" @click.self="closePopup">
      <div class="popup-content">
        <div class="popup-close" @click="closePopup">
          <img src="/static/image/event/close_popup.png" alt="关闭" />
        </div>
        <div class="popup-body">
          <img :src="popupItem.image" class="popup-img" alt="" />
          <div class="popup-name">{{ popupItem.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { recommendList } from './activityConfig';

export default {
  name: 'template3',
  props: {
    activityData: {
      type: Object,
      default: () => ({}),
    },
    from: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      applyCount: 0,
      showPopup: false,
      popupItem: null,
      topMenuItems: [
        { icon: '/static/image/event/2011393739796230145_01.avif' },
        { icon: '/static/image/event/2011393940099739650_03.avif' },
        { icon: '/static/image/event/2011393978355408897_05.avif' },
        { icon: '/static/image/event/2011401711114338306_04.avif' },
        { icon: '/static/image/event/2011407427363807234_02.avif' },
      ],
      recommendList,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollToActive();
    });
  },
  computed: {
    sliderImages() {
      const id = this.activityData.id;
      if (!id) return [];
      const images = [];
      for (let i = 1; i <= 41; i++) {
        const num = String(i).padStart(5, '0');
        images.push(`/static/image/event/ActiveImg${id}_${num}.avif`);
      }
      return images;
    },
    currentActivityConfig() {
      const id = String(this.activityData.id);
      return this.recommendList.find(item => item.activityId === id) || {};
    },
    showFooter() {
      return this.currentActivityConfig.apply_show === 1;
    },
  },
  methods: {
    handleRefresh() {
      // 刷新次数逻辑后续补充
    },
    handleApply() {
      if (!this.$store.state.token) {
        this.$parent.showTost(0, '请先登录');
        return;
      }
      this.$parent.showLoading();
      this.$apiFun.post('/api/doactivityapply', { activityid: this.activityData.id }).then(res => {
        this.$parent.hideLoading();
        this.$parent.showTost(res.code === 200 ? 1 : 0, res.message);
        if (res.code === 200 && res.data) {
          this.applyCount = res.data.remaining || 0;
        }
      }).catch(() => {
        this.$parent.hideLoading();
      });
    },
    handleJump(url) {
      // 跳转到对应活动的逻辑
      console.log('Jump to:', url);
    },
    chunkArray(arr, size) {
      const result = [];
      for (let i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size));
      }
      return result;
    },
    goRecommend(item) {
      if (item.popup === 1) {
        this.popupItem = item;
        this.showPopup = true;
      } else if (item.url_open === 1 && item.url) {
        window.location.href = item.url;
      } else if (item.jump) {
        this.$router.replace(`/activityDetail?template=${item.templateId}&activity_id=${item.activityId}&from=${this.from}`).catch(() => {});
      }
    },
    closePopup() {
      this.showPopup = false;
      this.popupItem = null;
    },
    scrollToActive() {
      const activeIndex = this.recommendList.findIndex(item => item.activityId === String(this.activityData.id));
      if (activeIndex === -1) return;

      const wrap = this.$refs.recommendWrap;
      const items = this.$refs['recItem' + activeIndex];
      if (!wrap || !items || !items[0]) return;

      const itemEl = items[0];
      const wrapWidth = wrap.offsetWidth;
      const itemLeft = itemEl.offsetLeft;
      const itemWidth = itemEl.offsetWidth;

      const scrollLeft = itemLeft - (wrapWidth / 2) + (itemWidth / 2);
      wrap.scrollTo({ left: Math.max(0, scrollLeft), behavior: 'smooth' });
    },
  },
};
</script>

<style lang="scss" scoped>
.template3 {
  padding-bottom: 1.2rem;
  background: #1e1f24;
  min-height: 100vh;
}

.template3 {
  background: #0a0a0a;
}

.t3-content {
  padding: 0.2rem;
}

.t3-top-banner {
  margin-bottom: 0.3rem;
  background: #0a0a0a;
  border-radius: 0.15rem;
  overflow: hidden;
  padding: 0;

  .top-banner-img {
    width: 100%;
    display: block;
  }
}

.t3-top-menu {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0.2rem 0;

  .t3-menu-item {
    .menu-icon {
      width: 1.35rem;
    }
  }
}

// 卡片区块
.t3-card {
  background: #0a0a0a;
  border-radius: 0.15rem;
  padding: 0.3rem;
  margin-bottom: 0.2rem;

  .card-title-icon {
    width: 50%;
    height: auto;
    display: block;
    margin: 0 auto 0.2rem;
  }

  .t3-title {
    font-size: 0.3rem;
    color: #e7c356;
    font-weight: 400;
    text-align: center;
    margin-bottom: 0.2rem;
  }

  .t3-text {
    font-size: 0.3rem;
    color: #fff;
    line-height: 1.6;
    text-align: left;
    width: 100%;
    font-weight: 400;
  }

  .t3-rules-title {
    font-size: 0.3rem;
    color: #e7c356;
    font-weight: 400;
    text-align: left;
    margin-bottom: 0.2rem;
  }

  .t3-rules {
    color: #fff;
    font-size: 0.3rem;
    font-weight: 400;
    line-height: 1.6;
    text-align: left;
  }

  .t3-rules p {
    margin: 0 0 0.1rem 0;
  }
}

// 综合优惠标题
.t3-special-title {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #d13b3b;
  border-radius: 0.1rem;
  padding: 0.2rem;
  margin: 0.25rem 0;

  span {
    font-size: 0.35rem;
    color: #ffd700;
    font-weight: bold;
  }
}

// 表格区块
.t3-table-wrap {
  margin-bottom: 0.1rem;
  background: #000;
  border-radius: 0.1rem;
  overflow: hidden;
  padding: 0.05rem;

  .t3-table {
    margin-bottom: 0.15rem;
  }

  .t3-table:last-child {
    margin-bottom: 0;
  }
}

// 表格样式
.t3-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.26rem;

  tbody td {
    padding: 0.15rem 0.1rem;
    text-align: center;
    color: #fff;
    font-size: 0.25rem;
    font-weight: 400;
    border: 1px solid #d13b3b;
    background: #000;
  }

  .t3-table-title {
    background: transparent;
    color: #ffd700;
    font-size: 0.3rem;
    font-weight: 400;
    padding: 0.2rem 0.1rem;
    text-align: center;
  }

  .gold-link {
    color: #ffd700;
    font-weight: 400;
    cursor: pointer;
  }

  .empty-cell {
    background: #000;
  }
}

.t3-table-note {
  font-size: 0.35rem;
  color: #fff;
  margin-top: 0.15rem;
  line-height: 1.6;
  font-weight: 600;
}

// 底部推荐图
.t3-recommend {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 0.2rem;

  .t3-recommend-inner {
    display: flex;
    gap: 0.15rem;
    width: max-content;
    margin-top: 0.5rem;
  }

  .t3-recommend-item {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .t3-recommend-img {
    width: 2.5rem;
    border-radius: 0.1rem;
    flex-shrink: 0;
    object-fit: cover;
    border: 1px solid transparent;
    box-sizing: border-box;
  }

  .t3-recommend-item.t3-recommend-active .t3-recommend-img {
    border: 1px solid #d1ae52;
  }

  .t3-recommend-name {
    width: 2.5rem;
    font-size: 0.24rem;
    color: #ccc;
    text-align: center;
    margin-top: 0.1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.t3-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #292a2c;
  padding: 0.25rem 0.2rem 0.5rem;
  box-sizing: border-box;
  z-index: 100;

  .t3-footer-info {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.2rem;
    font-size: 0.26rem;
    color: #888;
    margin-bottom: 0.25rem;

    .t3-refresh {
      color: #DFB372;
    }
  }

  .t3-footer-btns {
    display: flex;
    gap: 0.2rem;

    .t3-btn {
      flex: 1;
      height: 0.85rem;
      line-height: 0.85rem;
      border: none;
      border-radius: 0.4rem;
      font-size: 0.32rem;
      font-weight: 600;
      text-align: center;
    }

    .t3-btn-back {
      background: transparent;
      border: 1px solid #DFB372;
      color: #DFB372;
    }

    .t3-btn-apply {
      background: #898989;
      color: #fff;
    }
  }
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  .popup-content {
    position: relative;
    width: 80%;
    max-width: 3rem;
    background: #292a2c;
    border-radius: 0.1rem;
    padding: 0.2rem;
  }

  .popup-close {
    position: absolute;
    top: -0.4rem;
    right: -0.4rem;
    width: 0.4rem;
    height: 0.4rem;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .popup-body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .popup-img {
    width: 100%;
    border-radius: 0.1rem;
    margin-bottom: 0.1rem;
  }

  .popup-name {
    font-size: 0.28rem;
    color: #fff;
    text-align: center;
  }
}
</style>

<style>
.t3-text strong {
  color: #e6f41f;
}
.t3-table-note strong {
  color: #e6f41f;
}
.t3-rules {
  font-size: 0.35rem !important;
  color: #ccc !important;
  line-height: 1.8 !important;
  width: 100% !important;
}
.t3-rules strong {
  color: #e6f41f !important;
}
.t3-rules .blue-text {
  color: #7c90f3 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/activityDetail/template3.vue